import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Magnetic, useTitle } from "../components/Reveal";

export default function NotFound() {
  useTitle("Seite nicht gefunden – Manfred Berglar, Malermeister");
  return (
    <div className="min-h-screen bg-white text-ink flex items-center justify-center px-6">
      <div className="border border-line p-10 md:p-16 max-w-lg text-center" data-testid="not-found">
        <img src="/images/wappen.png" alt="Zunftwappen – Manfred Berglar, Malermeister" className="h-20 w-auto mx-auto" />
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase font-bold text-golddark mt-8">Fehler 404</p>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-balance mt-4">
          Hier wurde noch nicht gestrichen.
        </h1>
        <p className="text-muted leading-relaxed mt-4">
          Diese Seite existiert nicht (mehr). Zurück auf Anfang – dort ist frisch renoviert.
        </p>
        <Magnetic className="mt-8">
          <Link to="/" data-testid="not-found-home-link" className="btn-primary">
            Zur Startseite <ArrowUpRight size={16} />
          </Link>
        </Magnetic>
      </div>
    </div>
  );
}
